import React from 'react';

import SearchForm from 'components/SearchForm';

import {
  SearchFormHandle,
  TicketIndexRecord,
  TicketSearchProps,
} from 'lib/search';
import { typedForwardRef } from 'lib/utils';

/**
 * Search Form component with specific behavior for Ticket Search
 */
function TicketSearch<T extends TicketIndexRecord>(
  props: TicketSearchProps<T>,
  ref: React.ForwardedRef<SearchFormHandle<T>>
) {
  // Generate a unique key to force re-render of search client when sort field or order changes
  const formKey = `${props.algoliaIndexName}${props.sortByField || ''}${
    props.sortOrder || ''
  }`;
  return (
    <div className="ticket-search-container isd-search-tw w-full">
      <SearchForm key={formKey} ref={ref} {...props} driversOnly={false} />
    </div>
  );
}

export default typedForwardRef(TicketSearch);
